module.exports = __webpack_public_path__ + "static/media/react.4fddd779.svg";